import React, {Component} from 'react';
import CButton from '@/components/CButton'
import { connect} from 'react-redux'
import {bindActionCreators, compose} from 'redux'
import { withRouter} from 'react-router-dom'
import {Menu, Dropdown, Icon, message, Modal, Button} from 'antd';
import { setBreadcrumb} from "@/redux/common/action";
import {getStorage} from "@/utils";
import './index.scss'
import store from "../../redux";
import CSelect from "../../components/CForm/CSelect";
import{gepprovincelist} from "../../utils/gepdatadef";
import {selectLibraryHeader} from "../../servers/goodsManageApi";
import { setStorage} from "@/utils";

import {
  collapsedToggle,
  setWindowInfo,
  setUserInfo,
  setCurrentTheme,
  setUserList,
  setMenu, setLibrary, setLbname, refreshMenu, setLibraryArr,
} from "../../redux/common/action";
import config from '@/config'
import logo from '@/assets/images/cma-logo0.png'
import { loginout } from "@/servers/commonApi";
import {clearboth} from "../../utils/clear";
import {getALLMenu} from "../../servers/menuAPI";
class Header extends Component{

  constructor(props) {
    super(props);
    this.menuClick = this.menuClick.bind(this);
    this.changProvinceHandler = this.changProvinceHandler.bind(this)
    this.chooseLibbrary = this.chooseLibbrary.bind(this)
  }

  state = {
    time: null,
    museum:'',
    scoreinfo:{},
    provinve:gepprovincelist,
    provinceid:'',
    level:[
      {name:'一级',id:1410},
      {name:'二级',id:1411},
      {name:'三级',id:1412},
    ],
    levelid:'',
    library:[],
    libraryid:'',
    type:''
  };

  menuClick(){
    this.props.history.push({
      pathname: '/personinfo',
    });
  }

  componentWillMount(){
    const userInfo = getStorage('userList')
    this.setState({
      type:userInfo.clerklevel
    })
    if (userInfo.museumname) {
      this.setState({
        museum:userInfo.museumname,
      })
    } else {
      const state = store.getState()
      if (state.libraryname){
        const params = {
          museumname:state.libraryname,
        }
        selectLibraryHeader(params).then(res=>{
          this.setState({
            library:state.libraryarr,
            libraryid:state.libraryid,
          })
        })
      }
    }

    store.subscribe(() => {
      const state = store.getState()
      if (state.libraryname){
        this.setState({
          libraryid:state.libraryid,
          library:state.libraryarr
        })
      }
    })
  }

  logout(){
    Modal.confirm({
      content: '确认退出系统？',
      okText: '确认',
      cancelText: '取消',
      onCancel: () => {
      },
      onOk: () => {
        loginout().then(res => {
          if (res.statecode === 0) {
            // 退出
            window.location.href = '/'
            clearboth()
          } else {
            message.error(res.statemessage);
          }
        })
      }
    })
  }

  changProvinceHandler(value,type){
    this.setState({
      [type]:value
    },()=>{
      const params = {
        provinceid:this.state.provinceid,
        applylevelid:this.state.levelid
      }
      selectLibraryHeader(params).then(res=>{
        if (res.records.length > 0) {
          const result = res.records[0].scorelist
          this.props.setLibraryArr(result)
          this.setState({
            library:result,
          })
        } else {
          this.props.setLibraryArr([])
          this.setState({
            library:[],
          })
        }
      })
    })
  }

  chooseLibbrary(value){
    this.setState({
      libraryid:value
    })
    let str = ''
    for (let i =0;i<this.state.library.length;i++){
      if (this.state.library[i].id === value){
        str = this.state.library[i].name
        break
      }
    }
    this.props.setLibrary(value)
    this.props.setLbname(str)
    this.props.refreshMenu(true)
    const location = window.location.href
    console.log(location);
    if (location.includes('home')){
      let userInfo =JSON.parse(localStorage.getItem('userList'))
      if (userInfo.clerklevel == 3 || userInfo.clerklevel == 4 || userInfo.clerklevel == 16) {
        localStorage.setItem('chooseid','20131010')
        this.props.history.push({
          pathname: '/informationDeclaration/museumbaseinfo/baseCentral',
        });
      } else if (userInfo.clerklevel == 10 || userInfo.clerklevel == 11) {
        localStorage.setItem('chooseid','23131010')
        this.props.history.push({
          pathname: '/informationDeclaration/museumbaseinfo/baseScore',
        });
      } else {
        localStorage.setItem('chooseid','23131010')
        this.props.history.push({
          pathname: '/informationDeclaration/museumbaseinfo/baseProvince',
        });
      }
    }

  }

  componentWillUnmount(){
  }


  render(){
    const userList = JSON.parse(localStorage.getItem('userList'))
    let name = ''
    if (userList!==null && JSON.stringify(userList) !== '{}'){
      name = userList.clerkrealname;
    }
    const menu = (
        <Menu>
          <Menu.Item>
            <CButton type='text' block onClick={() => this.menuClick()}>个人信息</CButton>
          </Menu.Item>
        </Menu>);
    return (
      <header className='flex text-color-white header'>
        <div className='logo'>
          <img src={logo} alt=""/>
          {config.name}
        </div>
        <div className='flex info'>
          <div className='flex collapsed'>
            <Icon type="menu-fold" />
            <div className='breadcrumb'>
              {this.state.museum!=='' && this.state.museum!== null && this.state.museum!==undefined?this.state.museum:
               <div className='select-libbrary'>
                 {this.state.type == 6 || this.state.type == 7 ?'' :
                 <CSelect value={this.state.provinceid} options={this.state.provinve} placeholder='请选择所处省份'  onChange={(value)=>this.changProvinceHandler(value,'provinceid')}/>}
                 <CSelect value={this.state.levelid} options={this.state.level} placeholder='请选择申报等级'  onChange={(value)=>this.changProvinceHandler(value,'levelid')}/>
                 <div className='long'>
                   <CSelect value={this.state.libraryid} options={this.state.library} placeholder='请选择博物馆'  onChange={(value)=>this.chooseLibbrary(value,'libraryid')}/>
                 </div>
               </div>
              }
            </div>
          </div>
          <div className='flex info-right'>
        <div className='user-info' ref='userInfo'>
              <Dropdown overlay={menu} getPopupContainer={() => this.refs.userInfo}>
                <span>
                  {/*<img className='user-avatar' src={url} alt=""/>*/}
                  <span className='user-name'>
                    {name}</span>
                  <Icon type="down" />
                </span>
              </Dropdown>
              <span className='logoutindex' onClick={()=>{this.logout()}} style={{marginLeft:'30px',cursor:'pointer'}}>
                退出
              </span>
            </div>
          </div>
        </div>
      </header>
    )
  }
}


const mapStateToProps = (state) => {
  return {
    breadcrumbData: state.breadcrumbData,
    collapsed: state.collapsed,  // 侧边栏是否展开
    windowInfo: state.windowInfo,
    userInfo: state.userInfo,
    userList:  state.userList
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    collapsedToggle: bindActionCreators(collapsedToggle, dispatch),
    setWindowInfo: bindActionCreators(setWindowInfo, dispatch),
    setUserInfo: bindActionCreators(setUserInfo, dispatch),
    setCurrentTheme: bindActionCreators(setCurrentTheme, dispatch),
    setUserList:bindActionCreators(setUserList, dispatch),
    setMenu:bindActionCreators(setMenu,dispatch),
    setBreadcrumb: bindActionCreators(setBreadcrumb, dispatch),
    setLibrary: bindActionCreators(setLibrary, dispatch),
    setLbname: bindActionCreators(setLbname, dispatch),
    setLibraryArr: bindActionCreators(setLibraryArr, dispatch),
    refreshMenu: bindActionCreators(refreshMenu, dispatch),
  };
};

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(Header);
